export const TEST_ID = 'ghostButton';
